module.exports = "/_next/static/images/bank-mandiri-icon-18aeac7786046571aa9abe00cde2d8f3.svg";